import React, { useState, useEffect } from 'react';
import { Table, Input,message, Space, DatePicker, Select,Button ,Typography,Tag } from 'antd';
import SearchFieldsSelect, { useSearchFields, getSearchFieldsPlaceholder } from '../../Components/SearchFieldsSelect/SearchFieldsSelect';
const { Title, Text } = Typography;

import { SearchOutlined,ReloadOutlined,UserSwitchOutlined } from '@ant-design/icons';
import io from 'socket.io-client';
import dayjs from 'dayjs';
import API from '../../API/API';
import { useNavigate } from 'react-router-dom';
import Config from '../../API/Config';
const { RangePicker } = DatePicker;
const ErrorLeads = () => {
    const navigate = useNavigate();
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchFields, setSearchFields] = useSearchFields('error-lead:search-fields');
    // The "Search in" group only changes the results of a search, so changing it
    // with an empty search box sends no request.
    const effectiveSearchFields = searchTerm?.trim() ? searchFields : null;
    const [dateRange, setDateRange] = useState([
      dayjs().startOf('day'), 
      dayjs().add(1, 'day').startOf('day')
    ]);
        const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(30);
const [totalRecords,setTotalRecords]= useState(0);
const [agents, setAgents] = useState([]);

useEffect(() => {
    const fetchAgents = async () => {
        try {
            const res = await API.userGetAll(); // Adjust API call if needed
            if (res?.success) {
                setAgents(res.data);
            }
        } catch (err) {
            console.error("Failed to fetch agents:", err);
        }
    };

    fetchAgents();
}, []);
console.log(agents)

    const fetchLeads = async () => {
        setLoading(true);

        try {
            const userData = JSON.parse(localStorage.getItem("userData"));
            if (!userData?.id) {
                console.error("User authentication data not found");
                setLoading(false);
                return;
            }

            if (!Array.isArray(dateRange) || dateRange.length !== 2 || !dateRange[0] || !dateRange[1]) {
                console.error("Invalid date range format");
                setLoading(false);
                return;
            }

            const params = {
               dateField: 'createdAt',
                startDate: dateRange[0].format('YYYY-MM-DD'),
                endDate: dateRange[1].format('YYYY-MM-DD'),
                page: currentPage,
                limit: pageSize,
                status:"Error"
            };
            // Include search parameter if available
        if (searchTerm?.trim()) {
            params.search = searchTerm.trim();
            params.searchFields = searchFields;
        }
        

            if (JSON.parse(localStorage.getItem("userData"))?.role !== 'ADMIN') {
                params.agentId = JSON.parse(localStorage.getItem("userData"))?.id
            }
            console.log("API Request Params:", params); // ✅ Debug log

            // The server sends only the fields this page uses
            // (LeadController LEAD_VIEW_FIELDS['error-lead']).
            params.view = 'error-lead';
            const response = await API.leadGetAll(params);

            if (response?.status) {
                setLeads(response?.data);
                setTotalRecords(response.pagination.totalRecords); 
            } else {
                console.error("Invalid response format:", response);
                setLeads([]);
            }

        } catch (error) {
            console.error('Failed to fetch leads:', error);
            setLeads([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const delaySearch = setTimeout(() => {
            fetchLeads();
        }, 500); // Delays API call by 500ms to allow typing
    
        return () => clearTimeout(delaySearch);
    }, [currentPage, pageSize, dateRange, searchTerm, effectiveSearchFields]); 
   
    
    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const currentUserId = userData?.id;

        const socket = io(Config.baseURL, {
          reconnection: true,
          reconnectionAttempts: 5,
          reconnectionDelay: 1000,
        });
        const handleLeadAssigned = (newLead) => {
            console.log('New lead assigned:', newLead.lead);

            if (String(newLead.agentId) === String(currentUserId)) {
                setLeads(prevLeads => {
                    if (!prevLeads.some(lead => lead._id === newLead.lead._id)) {
                        return [newLead.lead, ...prevLeads];
                    }
                    return prevLeads;
                });
            }
        };

        socket.on('lead-assigned', handleLeadAssigned);

        socket.on('connect_error', (err) => {
            console.error('Socket connection error:', err);
        });

        return () => {
            socket.off('lead-assigned', handleLeadAssigned);
            socket.disconnect();
        };
    }, []);


    function formatToPST(isoDateString) {
        const date = new Date(isoDateString);


        const options = {
            timeZone: 'America/Los_Angeles',
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        };

        return date.toLocaleString('en-US', options);
    }

    const leadStageColors = {

        'Error': { color: '#ff4d4f', background: '#fff1f0' }, // Red, error
      };
      
    const columns = [


        { title: "Year", dataIndex: ["vehicleInfo", "year"], key: "year" },
        { title: "Make/Model", 
          dataIndex: ["vehicleInfo", "make"], 
          key: "make", 
          render: (text, record) => (
            <div>
              <strong>{record.vehicleInfo.make}</strong> <br />
              <span style={{ color: "#888" }}>{record.vehicleInfo.model}</span>
              <br />
              <span style={{ color: "#888" }}>{record.vehicleInfo.vin}</span>
            </div>
          ) 
        },
        { title: "Part", dataIndex: ["vehicleInfo", "part"], key: "part" },
        { 
          title: "Customer", 
          dataIndex: ["personalInfo", "fullName"], 
          key: "fullName", 
          render: (text, record) => (
            <div>
              <strong>{record.personalInfo.fullName}</strong> 
              {record.isExistingCustomer === true && (
              <UserSwitchOutlined style={{fontSize:"21px",color:"#1677ff",marginLeft:"10px"}} />

              )}   <br />
              <span style={{ color: "#888" }}>{record.personalInfo.email}</span>  <br />
              <span style={{ color: "#888" }}>{record.personalInfo.zipCode}</span>
             
            </div>
          ) 
        },
        {
            title: 'Status',
            dataIndex: 'leadStage',
            key: 'leadStage',
            width: 120,
            render: (stage) => {
              const styleConfig = leadStageColors[stage] || {
                color: '#000000',
                background: '#f5f5f5',
              };
        
              return (
                <Tag
                  style={{
                    color: styleConfig.color,
                    backgroundColor: styleConfig.background,
                    borderRadius: '8px',
                    fontWeight: 500,
                    padding: '0 12px',
                  }}
                >
                  {stage}
                </Tag>
              );
            },
          },
                    {
            title: 'Type',
            dataIndex: 'leadType',
            key: 'leadType',
            width: 120,
            render: (type) => {
              let color = '';
              let style = {
                borderRadius: '8px',
                fontWeight: 500,
                padding: '0 12px',
              };
        
              switch (type?.toLowerCase()) {
                case 'inbound':
                  color = '#52c41a'; // green
                  return (
                    <Tag color="green" style={style}>
                      INBOUND
                    </Tag>
                  );
        
                case 'outbound':
                  color = '#1890ff'; // blue
                  return (
                    <Tag color="blue" style={style}>
                      OUTBOUND
                    </Tag>
                  );
        
                default:
                  return (
                    <Tag color="default" style={style}>
                      {type?.toUpperCase() || 'UNKNOWN'}
                    </Tag>
                  );
              }
            },
          },
    
        
        { 
          title: "Date", 
          dataIndex: "createdAt", 
          key: "createdAt", 
          render: (date) => formatToPST(date) 
        },
        {
            title: "Assign Agent",
            key: "assignAgent",
            render: (_, record) => (
              <Select
                style={{ width: 160 }}
                placeholder="Select Agent"
                value={record.handledBy || undefined}
                onChange={async (selectedAgentId) => {
                  try {
                    const payload = { 
                      handledBy: selectedAgentId, 
                      leadStage: "New" 
                    };
                    const res = await API.UpdateLead(record._id, payload);
                    if (res?.status) {
                      message.success("Agent assigned successfully!");
                      fetchLeads(); // Refresh the table
                    } else {
                      message.error("Failed to assign agent.");
                    }
                  } catch (err) {
                    console.error("Error assigning agent:", err);
                    message.error("Something went wrong.");
                  }
                }}
              >
                {agents
                  .filter(agent => agent.role === 'SALES-AGENT')
                  .map(agent => (
                    <Select.Option key={agent._id} value={agent._id}>
                      {agent.firstName} {agent.lastName}
                    </Select.Option>
                  ))}
              </Select>
            ),
          }
          
          
        // {
        //     title: "Error Message", 
        //   dataIndex: "errorMessage", 
        //   key: "errorMessage", 
        // },
        // {
        //     title: "stack Trace", 
        //   dataIndex: "stackTrace", 
        //   key: "stackTrace", 
        // },
    ];
    
      
   


    return (
        <div >
       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
  <Space direction="vertical" size={2}>
    <Title level={2} style={{ fontWeight: "bold", margin: 0 }}>Error Lead Management</Title>
    <Text type="secondary">Track and manage your automotive service leads</Text>
  </Space>
          
          <Space>
            <RangePicker value={dateRange} onChange={(dates) => setDateRange(dates)}  
             disabledDate={(current) => {
             return current && current > dayjs().endOf('day');
            }}
           />
            <Space.Compact>
                <SearchFieldsSelect value={searchFields} onChange={setSearchFields} size="middle" />
                <Input
                    type="text"
                    placeholder={getSearchFieldsPlaceholder(searchFields)}
                    value={searchTerm}
                    onChange={(e) => {
                        console.log("Search Input Changed:", e.target.value); // ✅ Debug log
                        setSearchTerm(e.target.value);
                    }}
                    allowClear
                    suffix={<SearchOutlined />}
                    style={{ width: 260 }}
                />
            </Space.Compact>
            <Button icon={<ReloadOutlined />} onClick={fetchLeads} />
         
              <>
              

              </>
            
           
       

          </Space>
        </div>
  
        <Table
          columns={columns}
          dataSource={leads}
                    rowKey={(record) => record._id || record.key}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
            showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
            position: ['topRight'],
          }}
          onChange={handleTableChange}
scroll={{
    x: 'max-content',
    y: '55vh'
  }}  
          rowClassName={(record) => (selectedRowKeys.includes(record._id) ? "selected-row" : "")}
          expandable={{
            expandedRowRender: (record) => (
              <div style={{ padding: "10px 20px" }}>
                <p><strong>Error Message:</strong></p>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{record.errorMessage || 'N/A'}</pre>
        
                <p><strong>Stack Trace:</strong></p>
                <pre style={{
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  backgroundColor: '#f5f5f5',
                  padding: '10px',
                  borderRadius: '4px'
                }}>
                  {record.stackTrace || 'N/A'}
                </pre>
              </div>
            ),
            rowExpandable: (record) => !!record.errorMessage || !!record.stackTrace
          }}
          
      />
  

      </div>
    );
  };

export default ErrorLeads;


